import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import {renderField, renderFilePicker} from '../../Utils/renderField/renderField';
import ProfileForm from "./ProfileForm";
import {getMe} from "../../../../redux/modules/cuenta/login";


class Profile extends Component {

    constructor(props) {
        super(props);
        this.state = {photo: null};
    }

    componentDidMount() {
        this.props.getMe()
    }

    setAvatar = (photo) => {
        this.setState({photo});
    };

    update = (data) => {
        const { update } = this.props;
        data.username = data.no_dpi;
        update({...data, avatar: null}, [{"file": this.state.photo, "name": "photo"}]);
    };

    render() {
        const { me } = this.props;

        return (
            <ProfileForm onSubmit={this.update} me={me} setAvatar={this.setAvatar} />
        );
    }
}

export default reduxForm({
    form: 'profile', // a unique identifier for this form
})(Profile);
